// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"61da5a27","354":"880c3ad2","685":"f1a8d032","749":"b094819e","867":"b8c53be3","960":"b2eaf09e"}[chunkId] + ".chunk.css";
};